module.exports = __webpack_public_path__ + "img/4.024cd005.png";